import HtmlCallToActionOne from "./CallToAction/HtmlCallToActionOne";
import ContentTwoColumns from "./Content/ContentTwoColumns";
import HtmlContentFive from "./Content/HtmlContentFive";
import HtmlContentFour from "./Content/HtmlContentFour";
import HtmlContentOne from "./Content/HtmlContentOne";
import HtmlContentThree from "./Content/HtmlContentThree";
import HtmlContentTitleText from "./Content/HtmlContentTitleText";
import HtmlContentTwo from "./Content/HtmlContentTwo";
import HtmlTitleSimple from "./Content/HtmlTitleSimple";
import HtmlFeatureOne from "./Feature/HtmlFeatureOne";
import HtmlFeatureTwo from "./Feature/HtmlFeatureTwo";
import HtmlHeroOne from "./Hero/HtmlHeroOne";
import HtmlTeamOne from "./Team/HtmlTeamOne";
const elements = {
    "html-content-two-columns": ContentTwoColumns,
    "html-hero-hero-one": HtmlHeroOne,
    "html-content-content-one": HtmlContentOne,
    "html-feature-feature-one": HtmlFeatureOne,
    "html-team-one": HtmlTeamOne,
    "html-context-title-text": HtmlContentTitleText,
    "html-content-title-simple": HtmlTitleSimple,
    "html-content-content-two": HtmlContentTwo,
    "html-content-content-three": HtmlContentThree,
    "html-feature-feature-two": HtmlFeatureTwo,
    "html-content-content-four": HtmlContentFour,
    "html-content-content-five": HtmlContentFive,
    "html-call-to-action-one": HtmlCallToActionOne,
};
export default elements;
//# sourceMappingURL=index.js.map